import { Routes } from '@angular/router';
import { provideLessonStore } from '@app/store/lesson';
import { provideFormOptionsStore } from '@app/store/form-options';
import { ModalComponent } from '@shared/components';
import { AddComponent } from './add/add.component';
import { AddFormComponent } from './add/add-form/add-form.component';
import { ViewComponent } from './view/view.component';
import { EditComponent } from './edit/edit.component';

export const lessonsModalRoutes: Routes = [
    {
        path: 'lessons/add',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideLessonStore(), ...provideFormOptionsStore()],
        children: [
            { path: '', redirectTo: 'select', pathMatch: 'full' },
            { path: 'select', component: AddComponent },
            { path: ':type', component: AddFormComponent },
        ],
    },
    {
        path: 'lessons/view/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideLessonStore()],
        children: [{ path: '', component: ViewComponent }],
    },
    {
        path: 'lessons/edit/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideLessonStore(), ...provideFormOptionsStore()],
        children: [{ path: '', component: EditComponent }],
    },
];
